'use strict';

var _defineProperty = require("/home/keoadmin/agent/_work/68/s/node_modules/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/home/keoadmin/agent/_work/68/s/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _excluded = ["inputs"],
  _excluded2 = ["inputId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Declaration = require('./declaration');
var PreviousMap = require('./previous-map');
var Comment = require('./comment');
var AtRule = require('./at-rule');
var Input = require('./input');
var Root = require('./root');
var Rule = require('./rule');
function fromJSON(json, inputs) {
  if (Array.isArray(json)) return json.map(function (n) {
    return fromJSON(n);
  });
  var ownInputs = json.inputs,
    defaults = _objectWithoutProperties(json, _excluded);
  if (ownInputs) {
    inputs = [];
    var _iterator = _createForOfIteratorHelper(ownInputs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var input = _step.value;
        var inputHydrated = _objectSpread(_objectSpread({}, input), {}, {
          __proto__: Input.prototype
        });
        if (inputHydrated.map) {
          inputHydrated.map = _objectSpread(_objectSpread({}, inputHydrated.map), {}, {
            __proto__: PreviousMap.prototype
          });
        }
        inputs.push(inputHydrated);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(function (n) {
      return fromJSON(n, inputs);
    });
  }
  if (defaults.source) {
    var _defaults$source = defaults.source,
      inputId = _defaults$source.inputId,
      source = _objectWithoutProperties(_defaults$source, _excluded2);
    defaults.source = source;
    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }
  if (defaults.type === 'root') {
    return new Root(defaults);
  } else if (defaults.type === 'decl') {
    return new Declaration(defaults);
  } else if (defaults.type === 'rule') {
    return new Rule(defaults);
  } else if (defaults.type === 'comment') {
    return new Comment(defaults);
  } else if (defaults.type === 'atrule') {
    return new AtRule(defaults);
  } else {
    throw new Error('Unknown node type: ' + json.type);
  }
}
module.exports = fromJSON;
fromJSON.default = fromJSON;